module.exports = __webpack_public_path__ + "img/icon-name-璟馨.96f0c819.png";